import React from "react";
import { brandAccessLevelLabel } from "../lib/brandManagerStore";
import "./MaalBadge.css";

/**
 * Access-level badge on Brand Manager cards: "Limited" | "Full".
 * Internally this is Master Account Access Level (scope); Role stays separate.
 * Client-facing UI does not use the MAAL acronym.
 */
export default function MaalBadge({ accessLevel, roleScope }) {
  const raw = accessLevel || roleScope;
  const level =
    raw === "Full" || raw === "Limited"
      ? raw
      : brandAccessLevelLabel(raw);

  return (
    <div
      className="maal-badge company-type"
      data-testid="maal-badge"
      data-maal={level}
      aria-label={level}
    >
      <span className="maal-badge__text">{level}</span>
    </div>
  );
}
